import staticColors from './static/colors';
import staticScreenPrintingColor from './static/screenPrintingColors';
import staticPrintingArea from './static/printingAreas';
import staticSizes from './static/sizes';
import axios from 'axios';

const API_URL = '/api';

/**
 *
 * @return {Promise<ApiResponse>}
 */
export async function getData(displayDrafts = false) {
  const { data } = await axios.get(`${API_URL}/data-model.json`);

  // Remove draft products when draft mode is disabled
  if (!displayDrafts) {
    const filteredProducts = [];

    // create index and filter products
    const productMap = data.products.reduce((acc, p) => {
      acc[p.id] = p;

      if (!p.isDraft) {
        filteredProducts.push(p);
      }

      return acc;
    }, {});

    data.products = filteredProducts;

    // Filter productVariants
    data.productVariants = data.productVariants.filter(
      pv => productMap[pv.productId] && !productMap[pv.productId].isDraft
    );
  }

  // Merge static data
  data.colors = data.colors.map(color =>
    Object.assign(color, staticColors[color.id])
  );

  data.screenPrintingColors = data.screenPrintingColors.map(
    screenPrintingColor =>
      Object.assign(
        screenPrintingColor,
        staticScreenPrintingColor[screenPrintingColor.id]
      )
  );

  data.sizes = data.sizes.map(size =>
    Object.assign(size, staticSizes[size.id])
  );

  // Initialize product categories when not found
  data.products = data.products.map(p => {
    if (!p.categories) {
      p.categories = [];
    }

    return p;
  });

  // customProductsMock(data);

  data.printingAreas = data.printingAreas.map(printingArea =>
    Object.assign(printingArea, staticPrintingArea[printingArea.id])
  );

  return data;
}

/**
 *
 * @return {Promise<CartToken>}
 */
export async function requestToken() {
  const {
    data: { token },
  } = await axios.get(`${API_URL}/token`);

  return token;
}

/**
 *
 * @param {Blob|File} file
 * @param {string} token
 * @param {Function} onUploadProgress
 * @return {Promise<number>}
 */
export async function uploadFile(file, token, onUploadProgress) {
  if (!(file instanceof Blob || file instanceof File)) {
    throw new TypeError(
      'The provided file to upload is invalid (must be an instance of Blob or File).'
    );
  }

  const data = new FormData();
  data.append('file', file);

  const {
    data: { fileId },
  } = await axios.post(`${API_URL}/checkout/cart/upload`, data, {
    onUploadProgress,
    headers: {
      'X-CSRF-TOKEN': token,
      Accept: 'application/json',
    },
  });

  return fileId;
}

/**
 *
 * @param {ApiAddToCartRequest} requestData
 * @param {string} token
 * @return {Promise<void>}
 */
export async function addToCart(requestData, token) {
  const { data } = await axios.post(
    `${API_URL}/checkout/cart/add`,
    requestData,
    {
      headers: {
        'X-CSRF-TOKEN': token,
        Accept: 'application/json',
      },
    }
  );

  return data;
}

/**
 *
 * @param {ApiSaveCustomerProject} requestData
 * @param {string} token
 * @return {Promise<void>}
 */
export async function saveCustomerProject(requestData, token) {
  const { data } = await axios.post(
    `${API_URL}/customer-project/save`,
    requestData,
    {
      headers: {
        'X-CSRF-TOKEN': token,
        Accept: 'application/json',
      },
    }
  );

  return data;
}

/**
 *
 * @param {string} url
 * @param {ApiAddToCartRequest} data
 * @param {string} token
 * @return {Promise<void>}
 */
export async function updateOrder(url, data, token) {
  await axios.post(url, data, {
    headers: {
      'X-CSRF-TOKEN': token,
      Accept: 'application/json',
    },
  });
}
